import { css } from 'styled-components';

// Mirrors the public /services page shell so insights-v2 can share the same backdrop.
export const insightsV2ServicesBackground = css`
  background:
    radial-gradient(1200px 720px at 18% 8%, rgba(56, 189, 248, 0.32) 0%, rgba(56, 189, 248, 0) 62%),
    radial-gradient(1100px 760px at 84% 24%, rgba(168, 85, 247, 0.34) 0%, rgba(168, 85, 247, 0) 60%),
    radial-gradient(1200px 740px at 20% 50%, rgba(244, 114, 182, 0.3) 0%, rgba(244, 114, 182, 0) 62%),
    radial-gradient(1050px 700px at 82% 74%, rgba(251, 146, 60, 0.28) 0%, rgba(251, 146, 60, 0) 60%),
    radial-gradient(1200px 760px at 26% 94%, rgba(45, 212, 191, 0.3) 0%, rgba(45, 212, 191, 0) 64%),
    linear-gradient(180deg, #efecf0 0%, #efecf0 100%);
`;
